import common from "../../../utils/common";
import c from "../../../utils/constants";

class userCertificatesController {
  constructor() {
    "ngInject"
    
  }
  
  $onInit() {
    
    this.gridOptions = {
      dataSource: this.certificates,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Certificates."
      },
      columns: [
        { field: "category", title: "Category", filterable: false, width: "4rem", template: (dataItem) => `${this._getCategory(dataItem.category)}` },
        { field: "certificateTypeId", title: "Certificate Type", filterable: false, width: "4rem", template: (dataItem) => `${this._getCertificateType(dataItem.certificateTypeId)}` },
        { field: "certificateNumber", title: "Certificate Number", filterable: false, width: "4rem" },
        { field: "certificateStatus", title: "Certificate Status", filterable: false, width: "4rem", template: (dataItem) => `${this._getCertificateStatus(dataItem.certificateStatus)}` },
        { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", template: `#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #` },
        { field: "verificationDate", title: "Verification Date", filterable: false, width: "4rem", template: `#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #` },
      ]
    }
  }
  
  _getCertificateStatus(status) {
    switch(status) {
      case c.certificateStatus.PENDINGVERIFICATION:
        return "Pending Verification";
      case c.certificateStatus.ACTIVE:
        return "Active";
      case c.certificateStatus.INVALID:
        return "Invalid";
      case c.certificateStatus.EXPIRED:
        return "Expired";
    }
  }
  
  _getCategory(category) {
    switch(category) {
      case c.certificateCategory.CHECK: 
        return "Check";
      case c.certificateCategory.FIRSTAID: 
        return "First Aid";
      case c.certificateCategory.QUALIFICATION: 
        return "Qualification";
    }
  }
  
  
  _getCertificateType(type) {
    switch(type) {
      case c.certificateType.WWCC:
        return "WWCC";
    }
  }
  
}

export default userCertificatesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-certificates/user-certificates.controller.js
 **/